export const Header = (function () {
	'use strict';

	let $menu, $menuButton, $subMenuParent, $subMenuItem, $body, $subMenuBtn;

	function init() {
		($menu = $('.site-header__nav .nav-items')), ($menuButton = $('.mobile-menu-button'));
		$body = $('body');
		$subMenuParent = $('.site-header .menu-item-has-children');
		$subMenuItem = $('.site-header .sub-menu a');
		$subMenuBtn = $('.menu-item-has-children > a, .menu-item-has-children .sub-menu-toggle');

		events();
	}

	function events() {

		$menuButton.click(function () {

			if ($menu.hasClass('open')) {
				$body.removeClass('mobile-menu-open');
				$menu.removeClass('open');
				$menuButton.removeClass('open').attr('aria-expanded', 'false');
			} else {
				$body.addClass('mobile-menu-open');
				$menu.addClass('open');
				$menuButton.addClass('open').attr('aria-expanded', 'true');
			}
		});

		$subMenuBtn.click(function(e){
			if ( $(window).width() < 1160 ) {
				e.preventDefault();

				let $t = $(this),
						$li = $t.parents('li');

				if ($li.hasClass('sub-menu-open')) {
					$li.removeClass('sub-menu-open');
					$li.children('.sub-menu').stop().slideUp();
				} else {
					$li.addClass('sub-menu-open');
					$li.children('.sub-menu').stop().slideDown();
				}

			}
		});

	}

	return {
		init: init,
	};
})();
